import React from "react";
import { ReasonItem } from "./ReasonItem";
import { useTranslation } from "react-i18next";

import useAdvantages from "../../../rq/queries/useAdvantages";
import { BondTypes } from "../../../types/bond_types";

// import { importFiles } from "../../../utils/importFiles";
// const images = importFiles(require.context("./", false, /\.(png|jpe?g|svg)$/));

export const ReasonSection = ({ bondType = BondTypes.bond_type }) => {
  const [t] = useTranslation();

  const { data = [] } = useAdvantages({ bondType });

  return (
    !!data.length && (
      <section className="section-reason section">
        <div className="container">
          <div className="section-reason-inner">
            {/* <div className="attention-label">{t('reason_label')}</div> */}

            <div
              className="section-reason-content section-content"
              data-label={t("reason_label")}
            >
              <div className="section-label" data-label={t("reason_label")}>
                <h1 className="section-reason__title main-title section__title">
                  {t("reason_main_title")}
                </h1>
                <p className="section-reason__text title section__text">
                  {t("reason_main_text")}
                </p>
              </div>
              <div className="reason-list">
                {data
                  .sort((a, b) => a.order - b.order)
                  .map(
                    (
                      { title, text, highlight: simpleHighlight, image },
                      index
                    ) => {
                      const id = `reason${index}`;
                      // const image = images[id];

                      // const title = t(titleKey),
                      //   text = t(textKey),
                      //   highlight = t(highlightKey);

                      // const highlightAdditional =
                      //   highlightAdditionalKeys?.map((i) => t(i)) ?? [];

                      const highlight = simpleHighlight
                        .split("\r\n")
                        .map((str, index) => <p key={index}>{str}</p>); //('&#10;&#13;');
                      return (
                        <ReasonItem
                          key={index}
                          id={id}
                          image={image}
                          title={title}
                          text={text}
                          highlight={highlight}
                          // highlightAdditional={highlightAdditional}
                        />
                      );
                    }
                  )}
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  );
};
